module.exports = __webpack_public_path__ + "fonts/LatoLatin-SemiboldItalic.642f307.woff2";